import { Chip } from "@mui/material";
import NotesOutlinedIcon from "@mui/icons-material/NotesOutlined";
import { getEmptyChipStyles } from "./taskChipStyles";
import { ChipSize, UIComponentSize } from "@/types/shared/uiComponents";

interface NotesChipProps {
  /** Callback when chip is clicked */
  onClick: () => void;
  /** Whether the chip is disabled */
  disabled?: boolean;
  /** Chip size variant */
  size?: ChipSize;
  /** Custom label */
  label?: string;
}

export function NotesChip({
  onClick,
  disabled = false,
  size = UIComponentSize.Medium,
  label = "Notes",
}: NotesChipProps) {
  return (
    <Chip
      icon={<NotesOutlinedIcon />}
      label={label}
      onClick={disabled ? undefined : onClick}
      size="small"
      sx={getEmptyChipStyles({ size, clickable: !disabled })}
    />
  );
}
